export default "__VITE_ASSET__DTZGwQPs__"